<div class="pointer-events-none fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">
  <div
    class="w-[24rem] max-w-[calc(100vw-3rem)] origin-bottom-right transition-all duration-300 ease-out"
    [class]="
      isOpen()
        ? 'pointer-events-auto translate-y-0 scale-100 opacity-100'
        : 'pointer-events-none translate-y-4 scale-95 opacity-0'
    "
  >
    <div
      class="chat-panel flex max-h-[calc(100dvh-7.5rem)] flex-col overflow-hidden rounded-3xl bg-surface"
    >
      <div class="chat-header flex shrink-0 items-start gap-3 bg-primary px-5 py-4 text-on-primary">
        <div
          class="chat-avatar flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/20"
        >
          <mat-icon>{{ mode() === 'colleagues' ? 'groups' : 'support_agent' }}</mat-icon>
        </div>
        <div class="flex-1 leading-tight">
          <p>{{ headline() }}</p>
          <p class="text-sm text-on-primary/80">{{ subline() }}</p>
        </div>
        <button
          type="button"
          mat-icon-button
          class="!text-on-primary -mr-2 -mt-1"
          aria-label="Zavřít chat"
          (click)="toggle()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if (sent()) {
        <div
          class="flex min-h-0 flex-col items-center gap-4 overflow-y-auto px-5 py-10 text-center"
        >
          <div
            class="flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-green-700"
          >
            <mat-icon class="!h-8 !w-8 !text-3xl">check</mat-icon>
          </div>
          <p class="font-medium text-on-surface">
            {{
              mode() === 'colleagues'
                ? 'Zpráva byla odeslána kolegům.'
                : 'Email byl úspěšně odeslán. Brzy se ozveme.'
            }}
          </p>
          <button type="button" mat-stroked-button class="!rounded-full" (click)="writeAnother()">
            Napsat další zprávu
          </button>
        </div>
      } @else if (mode() === 'colleagues') {
        <form
          class="flex min-h-0 flex-col overflow-y-auto px-5 pb-5 pt-4"
          (ngSubmit)="sendToColleagues()"
        >
          <app-school-message-form [composer]="colleagueMessage" [bodyMinRows]="4" />

          <button
            type="submit"
            mat-flat-button
            color="primary"
            class="chat-send mt-4 !rounded-full !py-6"
            [disabled]="sending()"
          >
            <span class="inline-flex items-center justify-center gap-2">
              @if (sending()) {
                <mat-spinner diameter="20" />
                <span>Odesílám…</span>
              } @else {
                <mat-icon class="!m-0 !h-5 !w-5 !text-xl">send</mat-icon>
                <span class="text-base">Odeslat</span>
              }
            </span>
          </button>
        </form>
      } @else {
        <form
          class="flex min-h-0 flex-col gap-1 overflow-y-auto px-5 pb-5 pt-4"
          (ngSubmit)="send()"
        >
          <div
            class="mb-2 flex flex-col gap-1 rounded-2xl bg-surface-variant/40 px-4 py-2.5 text-sm"
          >
            <div class="flex items-center gap-2">
              <span class="w-8 shrink-0 text-on-surface-variant">Pro</span>
              <span class="truncate font-medium">{{ supportEmail }}</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-8 shrink-0 text-on-surface-variant">Od</span>
              <span class="truncate font-medium">{{ fromEmail() }}</span>
            </div>
          </div>

          @if (mode() === 'message') {
            @if (canOrderLicense()) {
              <div class="mb-3 flex flex-col gap-1.5">
                <button
                  type="button"
                  class="group flex w-full cursor-pointer items-center gap-2.5 rounded-xl border border-primary/20 bg-primary-container/40 px-3 py-2 text-left transition-colors hover:bg-primary-container/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                  (click)="startLicenseOrder()"
                >
                  <span
                    class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-on-primary"
                  >
                    <mat-icon class="!m-0 !h-4 !w-4 !text-base/none">workspace_premium</mat-icon>
                  </span>
                  <span class="flex-1 text-sm font-medium text-on-primary-container"
                  >Chceme objednat licenci</span
                  >
                  <mat-icon
                    class="!h-5 !w-5 shrink-0 !text-xl/none text-primary transition-transform group-hover:translate-x-0.5"
                  >
                    arrow_forward
                  </mat-icon>
                </button>
                <button
                  type="button"
                  class="group flex w-full cursor-pointer items-center gap-2.5 rounded-xl border border-primary/20 bg-primary-container/40 px-3 py-2 text-left transition-colors hover:bg-primary-container/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                  (click)="startCreditOrder()"
                >
                  <span
                    class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-on-primary"
                  >
                    <mat-icon class="!m-0 !h-4 !w-4 !text-base/none">bolt</mat-icon>
                  </span>
                  <span class="flex-1 text-sm font-medium text-on-primary-container"
                  >Chceme přikoupit AI kredity</span
                  >
                  <mat-icon
                    class="!h-5 !w-5 shrink-0 !text-xl/none text-primary transition-transform group-hover:translate-x-0.5"
                  >
                    arrow_forward
                  </mat-icon>
                </button>
                <button
                  type="button"
                  class="group flex w-full cursor-pointer items-center gap-2.5 rounded-xl border border-primary/20 bg-primary-container/40 px-3 py-2 text-left transition-colors hover:bg-primary-container/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                  (click)="startTrainingOrder()"
                >
                  <span
                    class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-on-primary"
                  >
                    <mat-icon class="!m-0 !h-4 !w-4 !text-base/none">school</mat-icon>
                  </span>
                  <span class="flex-1 text-sm font-medium text-on-primary-container"
                  >Chceme objednat školení</span
                  >
                  <span
                    class="shrink-0 rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-on-primary"
                    title="Sleva pro uživatele Mapy výuky"
                  >
                    −{{ trainingDiscountPercent }}&nbsp;%
                  </span>
                  <mat-icon
                    class="!h-5 !w-5 shrink-0 !text-xl/none text-primary transition-transform group-hover:translate-x-0.5"
                  >
                    arrow_forward
                  </mat-icon>
                </button>
              </div>
            }
          } @else {
            <div class="mb-3 flex items-center gap-2">
              <button
                type="button"
                mat-icon-button
                class="-ml-2"
                aria-label="Zpět na volnou zprávu"
                (click)="backToMessage()"
              >
                <mat-icon>arrow_back</mat-icon>
              </button>
              <span class="text-sm text-on-surface-variant">Zpět na volnou zprávu</span>
            </div>

            @if (mode() === 'credits') {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
                <mat-label>Počet balíčků</mat-label>
                <mat-select [(ngModel)]="packages" name="packages">
                  @for (option of creditPackageOptions; track option) {
                    <mat-option [value]="option">{{ creditPackageLabel(option) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div
                class="mt-3 flex items-baseline justify-between gap-2 rounded-2xl bg-primary-container/40 px-4 py-3"
              >
                <span class="text-sm text-on-surface-variant">Cena dle ceníku</span>
                <span class="text-right font-medium text-on-primary-container">
                  {{ creditPriceLabel() }}
                </span>
              </div>

              <p class="mt-2 text-xs text-on-surface-variant">
                Kredity se kupují nad rámec licence — balíček {{ creditPackageSizeLabel }} za
                {{ creditPackagePriceLabel }}.
              </p>
            } @else if (mode() === 'training') {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
                <mat-label>Forma školení</mat-label>
                <mat-select [(ngModel)]="trainingFormat" name="trainingFormat">
                  @for (option of trainingFormats; track option) {
                    <mat-option [value]="option">{{ trainingFormatLabel(option) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div
                class="mt-3 flex items-baseline justify-between gap-2 rounded-2xl bg-primary-container/40 px-4 py-3"
              >
                <span class="text-sm text-on-surface-variant">Cena</span>
                <span class="text-right font-medium text-on-primary-container">
                  na vyžádání, sleva {{ trainingDiscountPercent }}&nbsp;%
                </span>
              </div>

              <p class="mt-2 text-xs text-on-surface-variant">
                Rozsah 8 × 45 min. Do zprávy můžete doplnit počet účastníků a preferovaný termín.
              </p>
            } @else {
              <div class="flex gap-3">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-1">
                  <mat-label>Licence</mat-label>
                  <mat-select [(ngModel)]="tier" name="tier">
                    @for (option of orderableTiers; track option) {
                      <mat-option [value]="option">{{ tierLabel(option) }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-1">
                  <mat-label>Od měsíce</mat-label>
                  <mat-select [(ngModel)]="month" name="month">
                    @for (option of monthOptions(); track option.value) {
                      <mat-option [value]="option.value">{{ option.label }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="mt-3 w-full">
                <mat-label>Velikost školy</mat-label>
                <mat-select [(ngModel)]="size" name="size">
                  @for (option of sizeOptions; track option.band) {
                    <mat-option [value]="option.band">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div
                class="mt-3 flex items-baseline justify-between gap-2 rounded-2xl bg-primary-container/40 px-4 py-3"
              >
                <span class="text-sm text-on-surface-variant">Cena dle ceníku</span>
                <span class="text-right font-medium text-on-primary-container">
                  {{ priceLabel() }}
                </span>
              </div>

              <p class="mt-2 text-xs text-on-surface-variant">
                Objednávku na daný měsíc přijímáme do {{ orderDeadlineDay }}. dne toho měsíce.
              </p>
            }

            <div class="mt-3 flex items-start gap-2 text-xs text-on-surface-variant">
              @if (billingLoading()) {
                <mat-spinner diameter="16" />
                <span>Načítám fakturační údaje školy…</span>
              } @else if (hasBillingDetails()) {
                <mat-icon class="!m-0 !h-4 !w-4 shrink-0 !text-base leading-4 text-green-700">
                  check_circle
                </mat-icon>
                <span>Fakturační údaje jsme doplnili z profilu školy.</span>
              } @else {
                <mat-icon class="!m-0 !h-4 !w-4 shrink-0 !text-base leading-4">
                  info_outline
                </mat-icon>
                <span>
                  Škola v systému nemá vyplněné identifikační údaje — doplňte do zprávy fakturační
                  údaje.
                </span>
              }
            </div>
          }

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="mt-3">
            <mat-label>Předmět</mat-label>
            <input matInput [(ngModel)]="subject" name="subject" />
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="mt-3">
            <mat-label>Zpráva</mat-label>
            <textarea
              matInput
              [rows]="mode() === 'message' ? 4 : 8"
              [(ngModel)]="body"
              name="body"
            ></textarea>
          </mat-form-field>

          <button
            type="submit"
            mat-flat-button
            color="primary"
            class="chat-send mt-4 !rounded-full !py-6"
            [disabled]="!canSend() || sending()"
          >
            <span class="inline-flex items-center justify-center gap-2">
              @if (sending()) {
                <mat-spinner diameter="20" />
                <span>Odesílám…</span>
              } @else {
                <mat-icon class="!m-0 !h-5 !w-5 !text-xl">send</mat-icon>
                <span class="text-base">{{
                    mode() === 'message' ? 'Odeslat' : 'Odeslat objednávku'
                  }}</span>
              }
            </span>
          </button>
        </form>
      }
    </div>
  </div>

  @if (menuOpen()) {
    <div class="pointer-events-auto flex flex-col items-end gap-3" role="menu">
      <button
        type="button"
        role="menuitem"
        class="chat-fab flex cursor-pointer items-center gap-2.5 rounded-full bg-surface py-3 pl-4 pr-5 text-on-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        (click)="openColleagues()"
      >
        <mat-icon class="text-primary!">groups</mat-icon>
        <span>Napsat kolegům</span>
      </button>
      <button
        type="button"
        role="menuitem"
        class="chat-fab flex cursor-pointer items-center gap-2.5 rounded-full bg-surface py-3 pl-4 pr-5 text-on-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        (click)="openSupport()"
      >
        <mat-icon class="text-primary!">support_agent</mat-icon>
        <span>Napsat podpoře Mapy výuky</span>
      </button>
    </div>
  }

  <button
    type="button"
    class="chat-fab pointer-events-auto flex cursor-pointer items-center gap-2.5 rounded-full bg-primary py-4 pl-5 pr-6 text-on-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
    [attr.aria-label]="isOpen() || menuOpen() ? 'Zavřít' : 'Otevřít chat'"
    [attr.aria-expanded]="isOpen() || menuOpen()"
    (click)="toggle()"
  >
    <mat-icon
      class="!h-6 !w-6 !text-2xl transition-transform duration-300 ease-out"
      [class.rotate-90]="isOpen() || menuOpen()"
    >
      {{ isOpen() || menuOpen() ? 'close' : 'forum' }}
    </mat-icon>
    <span>{{ fabLabel() }}</span>
  </button>
</div>
